/* eslint-disable import/no-anonymous-default-export */
import siteConfig, { formatMoney } from "../siteConfig";

export default {
  path: "/international",
  shortTitle: "International",
  title: "International orders, duties and border charges",
  category: "Orders and delivery",
  summary: "How tracked routes from Hong Kong, border checks and import costs affect cross-border orders.",
  updated: "5 November 2026",
  sections: [
    {
      heading: "Available destinations",
      body: [
        `Checkout is limited to the countries and regions displayed in its selector. Orders leave the ${siteConfig.fulfilment.origin}; regional routes use ${siteConfig.fulfilment.carriers.regional}, while longer routes use ${siteConfig.fulfilment.carriers.international}. A missing destination is not currently offered.`,
        "A listed destination can still contain remote postcodes or product restrictions that the selected carrier cannot serve. If no compliant tracked route is available, customer care will contact the buyer before acceptance and reverse any captured amount rather than dispatch by an undisclosed substitute.",
      ],
    },
    {
      heading: "Duties, tax and clearance",
      body: [
        `The code charges merchandise and the flat ${formatMoney(siteConfig.shippingFee)} delivery fee. It does not calculate or collect an import duty, local tax, brokerage or clearance fee. A destination authority or delivery intermediary may assess charges under rules that depend on the goods, value, origin and recipient. No rate or exemption is promised here because those facts are not confirmed.`,
        "The recipient is responsible for accurate delivery and contact information and for responding to lawful clearance requests. Before ordering food, plant-fibre or bamboo goods cross-border, the customer should check whether the destination restricts them.",
      ],
    },
    {
      heading: "Dispatch and transit estimates",
      body: [
        `Orders normally dispatch within ${siteConfig.fulfilment.dispatchTime}. Regional transit is estimated at ${siteConfig.fulfilment.deliveryEstimates.regional}; other international transit is estimated at ${siteConfig.fulfilment.deliveryEstimates.international}. Customs and local hand-off can extend these estimates.`,
        siteConfig.fulfilment.trackingNotice,
      ],
    },
    {
      heading: "Refusal, return and delay",
      body: [
        "Border review can delay, hold, inspect or refuse a parcel. If a parcel returns because the recipient declined a lawful charge, supplied an incorrect address or did not complete clearance, customer care will assess the actual order facts before offering redelivery, refund or another remedy. The site does not invent a deduction schedule or automatic forfeiture.",
      ],
    },
    {
      heading: "Mandatory protections",
      body: [
        `Cross-border wording does not exclude non-waivable consumer rights in the customer's location or ${siteConfig.operatingRegion} rights that apply to the transaction. Contact customer care before purchase if a destination, material or charge is uncertain.`,
      ],
    },
  ],
};
